export default __webpack_public_path__ + "static/media/farmers1.57421783.jpg";